const CAROUSEL_ITEMS = [
  {
    title: '顶流明星恋情时间线全梳理',
    desc: '从暧昧互动到官宣公开，完整回顾这段引爆全网的娱乐圈恋情。',
    img: 'https://readdy.ai/api/search-image?query=A%20glamorous%20red%20carpet%20event%20with%20soft%20spotlight%20and%20elegant%20atmosphere%2C%20warm%20coral%20tones%2C%20editorial%20fashion%20photography%20style%2C%20luxurious%20textures%2C%20cinematic%20mood%2C%20no%20people%20faces%20visible%2C%20abstract%20glamour&width=500&height=320&seq=carousel-01-2026&orientation=landscape',
    tag: '娱乐圈',
  },
  {
    title: '年度综艺争议名场面合集',
    desc: '那些让观众集体破防的综艺名场面，争议背后的真相到底是什么。',
    img: 'https://readdy.ai/api/search-image?query=A%20colorful%20TV%20studio%20set%20with%20dramatic%20stage%20lighting%2C%20vibrant%20warm%20colors%20and%20teal%20accents%2C%20entertainment%20show%20atmosphere%2C%20creative%20stage%20design%2C%20cinematic%20wide%20shot%2C%20no%20people%2C%20professional%20broadcast%20environment&width=500&height=320&seq=carousel-02-2026&orientation=landscape',
    tag: '综艺',
  },
  {
    title: '塌房网红深度调查报告',
    desc: '人设崩塌背后的商业逻辑，网红经济的泡沫到底有多大？',
    img: 'https://readdy.ai/api/search-image?query=A%20shattered%20smartphone%20screen%20amongst%20scattered%20social%20media%20icons%20and%20notification%20bubbles%2C%20dramatic%20warm%20lighting%2C%20conceptual%20digital%20art%2C%20dark%20mood%20with%20coral%20highlights%2C%20editorial%20style%2C%20no%20text&width=500&height=320&seq=carousel-03-2026&orientation=landscape',
    tag: '网红',
  },
  {
    title: '企业家恩怨局完整复盘',
    desc: '商界大佬们的公开互怼，比任何商战剧都精彩的真实故事。',
    img: 'https://readdy.ai/api/search-image?query=A%20luxurious%20modern%20boardroom%20with%20dramatic%20shadows%20and%20warm%20ambient%20light%2C%20glass%20table%20reflections%2C%20corporate%20power%20symbolism%2C%20cinematic%20composition%2C%20teal%20and%20coral%20accents%2C%20no%20people%2C%20editorial%20photography&width=500&height=320&seq=carousel-04-2026&orientation=landscape',
    tag: '商业',
  },
  {
    title: '海外娱乐圈劲爆大事件',
    desc: '国际娱乐圈那些让人瞠目结舌的大瓜，跨越国界的八卦盛宴。',
    img: 'https://readdy.ai/api/search-image?query=A%20glamorous%20Hollywood%20style%20walk%20of%20fame%20with%20golden%20stars%20on%20the%20ground%2C%20warm%20sunset%20lighting%2C%20palm%20trees%20silhouette%2C%20luxurious%20vibe%2C%20cinematic%20wide%20angle%2C%20no%20people%2C%20entertainment%20industry%20atmosphere&width=500&height=320&seq=carousel-05-2026&orientation=landscape',
    tag: '国际',
  },
  {
    title: '社会热点事件的吃瓜视角',
    desc: '从另一个角度看社会热点，在信息洪流中找到独特解读。',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20newsroom%20with%20multiple%20screens%20displaying%20colorful%20abstract%20data%20visualizations%2C%20warm%20ambient%20lighting%2C%20digital%20information%20flow%2C%20contemporary%20media%20environment%2C%20editorial%20style%2C%20no%20people%2C%20clean%20composition&width=500&height=320&seq=carousel-06-2026&orientation=landscape',
    tag: '社会',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            51吃瓜网站精选深度专题，聚焦当下最受关注的热门事件
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <a
              key={item.title}
              href="#carousel"
              className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] font-semibold bg-primary-500 text-white px-2 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-bold text-foreground-900 mb-2 font-heading group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}